import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e1a176d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "creative-preview-toolbar" };
const _hoisted_2 = {
    key: 0,
    class: "creative-preview-toolbar__title"
};
const _hoisted_3 = { class: "creative-preview-toolbar__left" };
const _hoisted_4 = { class: "creative-preview-toolbar__right" };
const _hoisted_5 = { class: "creative-preview-toolbar__right__links" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-sync-alt" }, null, -1 /* HOISTED */));
const _hoisted_7 = ["href"];
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-external-link" }, null, -1 /* HOISTED */));
const _hoisted_9 = ["href"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-download" }, null, -1 /* HOISTED */));
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-upload" }, null, -1 /* HOISTED */));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-brackets-curly" }, null, -1 /* HOISTED */));
import { computed, ref, watch } from "vue";
import { useCampaignWorkingVariants } from "../../component-variable/composables/useCampaignWorkingVariants";
import CreativeActionCampaignFrontendAssetVariantSelector from "./CreativeActionCampaignFrontendAssetVariantSelector.vue";
import DeviceTypeSelector from "../../creative/DeviceTypeSelector.vue";
import Session from "js/Session";
import { isCreativeActionCampaignFrontendAsset, } from "src/shared/store/campaign-built/model/frontend-asset/CreativeActionCampaignFrontendAsset";
import DrawerTrigger from "../../ui/drawer/DrawerTrigger.vue";
import UploadCreativeArchiveDialog from "../dropdown-menu/UploadCreativeArchiveDialog.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignFrontendAssetPreviewToolbar',
    props: {
        frontendAsset: {},
        previewUrl: {},
        deviceType: {},
        variant: {},
        title: {},
        includeVariantSelector: { type: Boolean },
        debugShown: { type: Boolean },
        showUploadDownloadControls: { type: Boolean }
    },
    emits: ["update:deviceType", "update:variant", "update:debugShown", "onRefresh"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const isSuperUser = Session.getInstance().isSuperUser();
        const { workingVariants, deactivateWorkingVariant, activateWorkingVariant } = useCampaignWorkingVariants(() => props.frontendAsset.getCampaignId());
        watch(() => props.variant, (variant, oldVariant) => {
            if (workingVariants.value.length <= 1) {
                workingVariants.value.forEach((workingVariant) => {
                    deactivateWorkingVariant(workingVariant);
                });
                if (variant) {
                    activateWorkingVariant(variant);
                }
            }
            else {
                if (variant) {
                    activateWorkingVariant(variant);
                }
            }
        });
        const emit = __emit;
        const deviceTypeProxy = computed({
            get() {
                return props.deviceType;
            },
            set(value) {
                emit("update:deviceType", value);
            },
        });
        const previewVariantProxy = computed({
            get() {
                return props.variant;
            },
            set(value) {
                emit("update:variant", value);
            },
        });
        const downloadUrl = computed(() => {
            if (isCreativeActionCampaignFrontendAsset(props.frontendAsset)) {
                return props.frontendAsset.getCreativeDownloadUrl(props.frontendAsset.getDisplayName());
            }
            return null;
        });
        const isUploadDrawerOpen = ref(false);
        const openUploadDrawer = () => {
            isUploadDrawerOpen.value = true;
        };
        const isCreativeActionAsset = computed(() => {
            return isCreativeActionCampaignFrontendAsset(props.frontendAsset);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_3, [
                    (!_ctx.frontendAsset.isDesktopPreviewOnly())
                        ? (_openBlock(), _createBlock(DeviceTypeSelector, {
                            key: 0,
                            modelValue: deviceTypeProxy.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((deviceTypeProxy).value = $event))
                        }, null, 8 /* PROPS */, ["modelValue"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, [
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = ($event) => (emit('onRefresh')))
                        }, [
                            _hoisted_6,
                            _createTextVNode(" Refresh ")
                        ]),
                        _createElementVNode("a", {
                            target: "_blank",
                            href: _ctx.previewUrl || ''
                        }, [
                            _hoisted_8,
                            _createTextVNode(" Preview in New Tab ")
                        ], 8 /* PROPS */, _hoisted_7),
                        (_ctx.showUploadDownloadControls && downloadUrl.value)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: downloadUrl.value,
                                download: ""
                            }, [
                                _hoisted_10,
                                _createTextVNode(" Download ")
                            ], 8 /* PROPS */, _hoisted_9))
                            : _createCommentVNode("v-if", true),
                        (_ctx.showUploadDownloadControls && isCreativeActionAsset.value)
                            ? (_openBlock(), _createBlock(DrawerTrigger, { key: 1 }, {
                                trigger: _withCtx(({ openDrawer }) => [
                                    _createElementVNode("a", { onClick: openDrawer }, [
                                        _hoisted_12,
                                        _createTextVNode(" Upload ")
                                    ], 8 /* PROPS */, _hoisted_11)
                                ]),
                                drawer: _withCtx(({ drawerClosed }) => [
                                    _createVNode(UploadCreativeArchiveDialog, {
                                        creativeActionFrontendAsset: _ctx.frontendAsset,
                                        onClosed: drawerClosed
                                    }, null, 8 /* PROPS */, ["creativeActionFrontendAsset", "onClosed"])
                                ]),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true),
                        (_unref(isSuperUser))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 2,
                                onClick: _cache[2] || (_cache[2] = ($event) => (emit('update:debugShown', !_ctx.debugShown)))
                            }, [
                                _hoisted_13,
                                _createTextVNode(" Debug ")
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    (_ctx.includeVariantSelector)
                        ? (_openBlock(), _createBlock(CreativeActionCampaignFrontendAssetVariantSelector, {
                            key: 0,
                            "campaign-id": _ctx.frontendAsset.getCampaignId(),
                            variant: previewVariantProxy.value,
                            "onUpdate:variant": _cache[3] || (_cache[3] = ($event) => ((previewVariantProxy).value = $event))
                        }, null, 8 /* PROPS */, ["campaign-id", "variant"]))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
